<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input [hidden]="businessId === '0'" ttLabel="business_id" [ttModel]="edit.business_id" ttReadonly></tt-input>
        <tt-input [hidden]="businessId !== '0'" ttLabel="business_id" [(ttModel)]="edit.business_id" ttRequired></tt-input>
        <tt-input ttLabel="business_name" [(ttModel)]="edit.business_name" ttRequired></tt-input>
        <tt-button-save ttText="business_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ng-if="vm.model.businessId === '0'" class="col-xs-12 sp-0" tt-label="business_id" tt-model="vm.model.edit.business_id" tt-change="vm.model.edit.business_id = $value" tt-placeholder=""></tt-input>
        <tt-input ng-if="vm.model.businessId !== '0'" class="col-xs-12 sp-0" tt-label="business_id" tt-model="vm.model.edit.business_id" tt-change="vm.model.edit.business_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="business_name" tt-model="vm.model.edit.business_name" tt-change="vm.model.edit.business_name = $value" tt-placeholder=""></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="business_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
